import { Route } from '@/processes/common/api/types';

export const TSD_MENU_URL = <Route> { url: '/v2/tsd/menu', method: 'GET' };

export default null;
